import { useNavigate } from 'react-router-dom';
import { realLinkProps, type RealLinkOptions } from './realLinkProps';

/** react-router's navigate, as the real-link module's `navigate`. */
export function useRouterNavigate() {
  const navigate = useNavigate();
  // programmatic-nav: the router behind a real <a href>; realLink.tsx only calls it for a plain left click.
  return (href: string) => navigate(href);
}

/** Props for a component that renders its own anchor: `<Button as="a" {...useEntityLinkProps('/x')}>`. */
export function useEntityLinkProps(href: string, options: Omit<RealLinkOptions, 'navigate'> = {}) {
  return realLinkProps(href, { ...options, navigate: useRouterNavigate() });
}
